import { ButtonType } from '../../components/base-button';
import { RainbowColor } from '../enums/RainbowColor';

export class RainbowColorHelper {
  static button = (type: ButtonType, color: RainbowColor) => {
    if (type === ButtonType.Secondary) {
      return [`color-border-${color}`, `light-hover-bg-${color}`, `color-text-${color}`];
    }
    return [`light-bg-${color}`, `color-text-${color}`];
  };

  static getStyle = (number?: number) => {
    const colors = Object.values(RainbowColor);
    const index = number || Math.floor(Math.random() * colors.length);
    const color = colors[index];
    return [`light-bg-${color}`, `color-text-${color}`];
  };

  static text = (color: RainbowColor) => `color-text-${color}`;

  static background = (color: RainbowColor) => `light-static-bg-${color}`;

  static getLightBackground = (number?: number) => {
    const colors = Object.values(RainbowColor);
    const index = number || Math.floor(Math.random() * colors.length);
    const color = colors[index];
    return `light-static-bg-${color}`;
  };
}
